var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNeedYourApprovalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "#CC5078",
    fillOpacity: 0.12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 15.9983C21.001 15.4976 20.8767 15.0046 20.6384 14.5643C20.4001 14.124 20.0554 13.7503 19.6357 13.4773C19.2159 13.2043 18.7346 13.0407 18.2354 13.0014C17.7363 12.9621 17.2353 13.0484 16.778 13.2523C16.3208 13.4563 15.9218 13.7714 15.6176 14.169C15.3133 14.5666 15.1134 15.0341 15.036 15.5287C14.9587 16.0234 15.0064 16.5296 15.1747 17.0011C15.3431 17.4726 15.6268 17.8945 16 18.2283V21.9983L18 21.0513L20 21.9983V18.2283C20.3143 17.9479 20.5659 17.6044 20.7382 17.2201C20.9106 16.8358 20.9998 16.4194 21 15.9983ZM19 20.4183L18 19.9448L17 20.4183V18.8233C17.6463 19.0561 18.3537 19.0561 19 18.8233V20.4183ZM18 17.9983C17.6044 17.9983 17.2178 17.881 16.8889 17.6612C16.56 17.4414 16.3036 17.1291 16.1522 16.7636C16.0009 16.3982 15.9613 15.996 16.0384 15.6081C16.1156 15.2201 16.3061 14.8637 16.5858 14.584C16.8655 14.3043 17.2219 14.1139 17.6098 14.0367C17.9978 13.9595 18.3999 13.9991 18.7654 14.1505C19.1308 14.3019 19.4432 14.5582 19.6629 14.8871C19.8827 15.216 20 15.6027 20 15.9983C19.9993 16.5285 19.7884 17.0368 19.4135 17.4117C19.0385 17.7867 18.5302 17.9976 18 17.9983Z",
    fill: "#CC5078"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 8.5H17V8C16.9992 7.73503 16.8936 7.48113 16.7062 7.29377C16.5189 7.1064 16.265 7.00079 16 7H12C11.735 7.00079 11.4811 7.1064 11.2938 7.29377C11.1064 7.48113 11.0008 7.73503 11 8V8.5H9.5C9.23503 8.50079 8.98113 8.6064 8.79377 8.79377C8.6064 8.98113 8.50079 9.23503 8.5 9.5V20C8.50079 20.265 8.6064 20.5189 8.79377 20.7062C8.98113 20.8936 9.23503 20.9992 9.5 21H14V20H9.5V9.5H11V11H17V9.5H18.5V12H19.5V9.5C19.4992 9.23503 19.3936 8.98113 19.2062 8.79377C19.0189 8.6064 18.765 8.50079 18.5 8.5ZM16 10H12V8H16V10Z",
    fill: "#CC5078"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeedYourApprovalIcon);
export default __webpack_public_path__ + "static/media/NeedYourApprovalIcon.527f204dbeef00b543e75830c1f91d6f.svg";
export { ForwardRef as ReactComponent };